import { createSlice } from '@reduxjs/toolkit';
import addOnSelectionApi from '@custom/rtk-apis/hospital/addOnSelectionApi';

const addOnSelectionSlice = createSlice({
    name: 'addOnSelectionSlice',
    initialState: {
      result: null,
      status: null,
      loading: false,
      error: null,
      success: false,
    },
    reducers: {
      resetAddOnState: (state) => {
        state.result = null;
        state.status = null;
        state.loading = false;
        state.error = null;
        state.success = false;
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(addOnSelectionApi.pending, (state) => {
          state.loading = true;
          state.error = null;
          state.success = false;
        })
        .addCase(addOnSelectionApi.fulfilled, (state, action) => {
          console.log('Fetched payload:', action.payload);
          state.result = action.payload;
          state.status = "SUCCESS";
          state.loading = false;
          state.success = true;
        })
        .addCase(addOnSelectionApi.rejected, (state, action) => {
          state.loading = false;
          state.status = "FAILED";
          state.error = action.payload;
          state.success = false;
        });
    },
  });

  export default addOnSelectionSlice.reducer;
  export const { resetAddOnState } = addOnSelectionSlice.actions
